import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Input, InputNumber, Select, Space, Table, Tag, Tooltip, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import tmAdminExtService from '../../services/tmAdminExtService';
import { fmtTime, toastErr } from './common';
import { StreamRef, askReason, runOp } from './opsCommon';
import StreamOpsDrawer from './StreamOpsDrawer';

const { Text } = Typography;

const ApiKeys = () => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState({ current: 1, pageSize: 50 });
    const [f, setF] = useState({ revoked: 0 });
    const [streamId, setStreamId] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const r = await tmAdminExtService.listApiKeys({ ...f, page: page.current, per_page: page.pageSize });
            setRows(r?.data?.items || []);
            setTotal(r?.data?.total || 0);
        } catch (e) {
            toastErr(e, '加载失败');
        } finally {
            setLoading(false);
        }
    }, [f, page]);

    useEffect(() => { load(); }, [load]);

    const setFilter = (patch) => { setF((x) => ({ ...x, ...patch })); setPage((p) => ({ ...p, current: 1 })); };

    const columns = [
        { title: '前缀', dataIndex: 'prefix', width: 140, render: (v) => <Text code>{v}…</Text> },
        { title: '名称', dataIndex: 'name' },
        { title: '发信流', key: 's', width: 180, render: (_, k) => <StreamRef stream={k.stream} onOpen={setStreamId} /> },
        { title: '用户', key: 'u', render: (_, k) => <span>#{k.user.id} {k.user.username}<br /><Text type="secondary" style={{ fontSize: 12 }}>{k.user.email}</Text></span> },
        { title: '创建', dataIndex: 'created_at', width: 150, render: fmtTime },
        { title: '最近使用', dataIndex: 'last_used_at', width: 150, render: fmtTime },
        {
            title: '状态', key: 'st', width: 90,
            render: (_, k) => (k.revoked ? <Tooltip title={`${k.revoked_reason || ''} ${fmtTime(k.revoked_at)}`}><Tag>已吊销</Tag></Tooltip> : <Tag color="green">有效</Tag>),
        },
        {
            title: '', key: 'op', width: 80,
            render: (_, k) => (k.revoked ? null : (
                <Button type="link" size="small" danger onClick={() => askReason(`吊销 ${k.prefix}…`, '管理员吊销', (r) => runOp(() => tmAdminExtService.revokeApiKey(k.id, r), '已吊销', load))}>吊销</Button>
            )),
        },
    ];

    return (
        <Card title="API 密钥" extra={<Button icon={<ReloadOutlined />} onClick={load} />}>
            <Space wrap style={{ marginBottom: 12 }}>
                <Input.Search allowClear placeholder="名称 / 前缀" style={{ width: 200 }} onSearch={(v) => setFilter({ q: v.trim() || undefined })} />
                <Input.Search allowClear placeholder="用户 ID / 邮箱" style={{ width: 200 }} onSearch={(v) => setFilter({ user: v.trim() || undefined })} />
                <InputNumber placeholder="发信流 ID" min={1} style={{ width: 110 }} onChange={(v) => setFilter({ stream_id: v || undefined })} />
                <Select allowClear placeholder="全部" style={{ width: 100 }} value={f.revoked} options={[{ value: 0, label: '有效' }, { value: 1, label: '已吊销' }]} onChange={(v) => setFilter({ revoked: v })} />
            </Space>
            <Table rowKey="id" size="small" loading={loading} dataSource={rows} columns={columns} scroll={{ x: 1100 }}
                pagination={{ ...page, total, showSizeChanger: true, onChange: (current, pageSize) => setPage({ current, pageSize }) }} />
            <StreamOpsDrawer streamId={streamId} onClose={() => setStreamId(null)} onChanged={load} />
        </Card>
    );
};

export default ApiKeys;
